module.exports = __webpack_public_path__ + "img/pic24.d58ea3f5.jpg";